import { Link, useLocation } from "react-router-dom";
import { isAuthenticated, logout, getUserFromToken } from "../utils/auth";
import { useState, useEffect, useRef, useCallback } from "react";
import { FiActivity, FiBriefcase, FiLogOut, FiMail, FiShield, FiUser } from "react-icons/fi";
import logoB from "../assets/logoB.png";
import './Navbar.css'

const Navbar = () => {
  const location = useLocation();
  const user = getUserFromToken();
  const collapseRef = useRef(null);
  const navbarRef = useRef(null);
  const [collapseInstance, setCollapseInstance] = useState(null);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const handleNavClick = useCallback(() => {
    collapseInstance?.hide();
  }, [collapseInstance]);

  const performLogout = useCallback(() => {
    logout();
  }, []);

  const requestLogout = useCallback(() => {
    handleNavClick();
    setShowLogoutConfirm(true);
  }, [handleNavClick]);

  useEffect(() => {
    if (localStorage.getItem("token") && !isAuthenticated()) {
      performLogout();
    }
  }, [performLogout]);

  useEffect(() => {
    if (collapseRef.current && window.bootstrap?.Collapse) {
      const bsCollapse = new window.bootstrap.Collapse(
        collapseRef.current,
        { toggle: false }
      );
      setCollapseInstance(bsCollapse);

      return () => bsCollapse.dispose();
    }
  }, []);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        collapseRef.current &&
        !collapseRef.current.contains(event.target) &&
        collapseInstance
      ) {
        collapseInstance.hide();
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [collapseInstance]);

  // Add blur background on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (!navbarRef.current) return;

      if (window.scrollY > 50) {
        navbarRef.current.classList.add("navbar-scrolled");
      } else {
        navbarRef.current.classList.remove("navbar-scrolled");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <nav
        ref={navbarRef}
        className={`navbar navbar-expand-lg fixed-top custom-navbar ${
          location.pathname === "/login" ? "login-navbar navbar-dark" : "navbar-light"
        }`}
      >
        <div className="container-fluid">
          <Link
            className="navbar-brand"
            to="/email-automation"
            onClick={handleNavClick}
          >
            <img
              src={logoB}
              alt="Logo"
              className="navbar-logo"
            />
            <span className="mx-1 small ">Admin</span>
          </Link>

          {user && <>
          <button
            className="navbar-toggler custom-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavAltMarkup"
            aria-label="Toggle navigation"
          >
            <span />
            <span />
            <span />
          </button>

          <div
            className="collapse navbar-collapse"
            id="navbarNavAltMarkup"
            ref={collapseRef}
          >
            <div className="navbar-nav me-auto">
              <Link className={`nav-link ${location.pathname === "/email-automation" ? "active" : ""}`} to="/email-automation" onClick={handleNavClick}>
                <FiMail aria-hidden="true" />
                <span>Email Automations</span>
              </Link>
              <Link className={`nav-link ${location.pathname === "/civinex-leads" ? "active" : ""}`} to="/civinex-leads" onClick={handleNavClick}>
                <FiBriefcase aria-hidden="true" />
                <span>Civinex Leads</span>
              </Link>
              <Link className={`nav-link ${location.pathname === "/civinex-issues" ? "active" : ""}`} to="/civinex-issues" onClick={handleNavClick}>
                <FiActivity aria-hidden="true" />
                <span>Issues</span>
              </Link>
            </div>

            <div className="navbar-account">
              <div className="profile-chip">
                <span className="profile-avatar">
                  <FiUser aria-hidden="true" />
                </span>
                <span className="profile-copy">
                  <span className="profile-label">Signed in</span>
                  <strong>{user}</strong>
                </span>
              </div>
              <button
                type="button"
                className="logout-btn"
                onClick={requestLogout}
              >
                <FiLogOut aria-hidden="true" />
                <span>Logout</span>
              </button>
            </div>
          </div>
          </>}
        </div>
      </nav>

      {showLogoutConfirm && (
        <div className="logout-modal-backdrop" role="presentation" onClick={() => setShowLogoutConfirm(false)}>
          <div
            className="logout-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="logout-title"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="logout-modal-icon">
              <FiShield aria-hidden="true" />
            </div>
            <h2 id="logout-title">Log out of workspace?</h2>
            <p>
              You will need to sign in again to access uploads, reports, leads, and issues.
            </p>
            <div className="logout-modal-actions">
              <button type="button" className="btn btn-outline-light" onClick={() => setShowLogoutConfirm(false)}>
                Cancel
              </button>
              <button type="button" className="btn confirm-logout-btn" onClick={performLogout}>
                <FiLogOut aria-hidden="true" />
                Log Out
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
